"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var DefaultSubmitField = function DefaultSubmitField(props) {
  return _react.default.createElement(_core.Button, _extends({
    style: {
      margin: '1rem 0'
    },
    type: 'submit',
    variant: 'contained',
    color: 'primary',
    fullWidth: true
  }, props), props.label);
};

DefaultSubmitField.defaultProps = {
  label: 'Submit'
};
DefaultSubmitField.propTypes = {
  label: _propTypes.default.string.isRequired
};
var _default = DefaultSubmitField;
exports.default = _default;